<div class="m-subheader" style="position: relative;">
  <div [ngClass]="{'invisible': !invoice && isLoading.invoice }" class="d-flex align-items-center" style="flex-wrap: wrap;">
    <div class="mr-auto">
      <ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
        <li class="m-nav__item m-nav__item--home">
          <a routerLink="/" class="m-nav__link m-nav__link--icon">
            <i class="m-nav__link-icon la la-home"></i>
          </a>
        </li>
        <li class="m-nav__separator">
          -
        </li>
        <li class="m-nav__item">
          <a routerLink="../" class="m-nav__link">
            <span class="m-nav__link-text">
              {{ 'storage-invoices-receive.allInvoices' | transloco }}
            </span>
          </a>
        </li>
        <li class="m-nav__item">
        </li>
      </ul>
    </div>
  </div>

  <div *ngIf="!invoice && isLoading.invoice" class="m-page-loader m-page-loader--non-block m-page-loader--absolute">
    <div class="m-loader m-loader--brand"></div>
  </div>
</div>

<div class="m-content">
  <div class="row">
    <div class="col-sm-12">
      <div class="m-portlet m-portlet--head-solid-bg">
        <div class="m-portlet__head" style="position: relative;">
          <div [ngClass]="{'invisible': !invoice && isLoading.invoice }" class="m-portlet__head-caption">
            <div class="m-portlet__head-title">
              <h3 class="m-portlet__head-text">
                {{ 'storage-invoices-receive.acceptInvoice' | transloco }} {{ invoice?.number }}
              </h3>
            </div>
          </div>

          <div *ngIf="!invoice && isLoading.invoice" class="m-page-loader m-page-loader--non-block m-page-loader--absolute">
            <div class="m-loader m-loader--brand"></div>
          </div>
        </div>

        <div class="m-portlet__body">
          <div *ngIf="invoice && !isLoading.invoice" class="row">
            <div class="col-md-12">
              <form class="m-form m-form--state" [formGroup]="invoiceForm" (ngSubmit)="onSubmitForm()">
                <div class="m-form__section">
                  <div class="form-group m-form__group row">
                    <label class="col-form-label col-lg-3 col-sm-12">
                      {{ 'storage-invoices-receive.supplier' | transloco }}:
                    </label>

                    <div class="col-lg-6 col-md-6 col-sm-12">
                      {{ invoice.supplier?.name }} ({{ invoice.supplier?.uin }})
                    </div>
                  </div>

                  <div class="form-group m-form__group row">
                    <label class="col-form-label col-lg-3 col-sm-12">
                      {{ 'storage-invoices-receive.number' | transloco }}:
                    </label>
                    <div class="col-lg-4 col-md-4 col-sm-12">
                      {{ invoice.incomingInvoiceNumber }}
                    </div>
                  </div>

                  <div class="form-group m-form__group row">
                    <label class="col-form-label col-lg-3 col-sm-12 is--required">
                      {{ 'storage-invoices-receive.data' | transloco }}:
                    </label>
                    <div class="col-lg-4 col-md-4 col-sm-12">
                      <hx-date-select [formControlName]="invoiceFormKeys.incomingInvoiceDate"></hx-date-select>
                    </div>
                  </div>

                  <div class="form-group m-form__group row">
                    <label class="col-form-label col-lg-3 col-sm-12">
                      {{ 'storage-invoices-receive.typePaid' | transloco }}:
                    </label>

                    <div class="col-lg-4 col-md-4 col-sm-12">
                      <select [formControlName]="invoiceFormKeys.paymentType" class="form-control m-input m-input--square">
                        <option value="">{{ 'storage-invoices-receive.noChoose' | transloco }}</option>

                        <option *ngFor="let type of types" [value]="type">{{ 'storageinvoice.paymenttype.' + type | transloco }}</option>
                      </select>
                    </div>
                  </div>

                  <div class="form-group m-form__group row">
                    <label class="col-form-label col-lg-3 col-sm-12 is--required">
                      {{ 'storage-invoices-receive.expenses' | transloco }}:
                    </label>

                    <div class="col-lg-6 col-md-6 col-sm-12">
                      <app-spend-category-search [code]="invoiceForm.get(invoiceFormKeys.spendCategory).value" (update)="selectSpendCategory($event)"></app-spend-category-search>
                    </div>
                  </div>

                  <table class="table m--margin-bottom-0">
                    <thead class="thead-default">
                    <tr>
                      <th>{{ 'storage-invoices-receive.table.head.product' | transloco }}</th>
                    </tr>
                    </thead>
                  </table>
                  <div class="is--responsive-table">
                    <table class="table">
                      <thead>
                      <tr>
                        <th>{{ 'storage-invoices-receive.table.head.name' | transloco }}</th>
                        <th class="text-right">{{ 'storage-invoices-receive.table.head.num' | transloco }}</th>
                        <th class="text-right">{{ 'storage-invoices-receive.table.head.quantity' | transloco }}</th>
                        <th class="text-right">{{ 'storage-invoices-receive.table.head.price' | transloco }}</th>
                        <th class="text-right">{{ 'storage-invoices-receive.table.head.sum' | transloco }}</th>
                      </tr>
                      </thead>
                      <tbody>
                      <ng-container *ngFor="let product of invoice.products">
                        <tr>
                          <td>
                            {{ product.title | uiLabel }}
                          </td>

                          <td class="text-right">
                            {{ product.unitOfMeasureTitle | uiLabel }}
                          </td>

                          <td class="text-right text-nowrap">
                            {{ product.amount }}
                          </td>
                          <td class="text-right text-nowrap">
                            {{ product.pricePerUnit }}
                          </td>
                          <td class="text-right text-nowrap">
                            {{ product.totalValue | uiCurrency:invoice.currency}}
                          </td>
                        </tr>
                      </ng-container>
                      <tr>
                        <td>
                          <h5>{{ 'storage-invoices-receive.table.head.total' | transloco }}</h5>
                        </td>

                        <td></td>
                        <td></td>
                        <td></td>

                        <td class="text-right text-nowrap">
                          <h5 class="m--font-success">
                            {{ invoice.totalPrice | uiCurrency:invoice.currency }}
                          </h5>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="m-form__actions m-form__actions--paddingless-sides">
                  <div class="row">
                    <div class="col-12 text-right">
                      <button [disabled]="isLoading?.submit" type="submit" class="btn btn-success">
                        {{ 'storage-invoices-receive.btn.accept' | transloco }}
                      </button>
                      <a *ngIf="hasPermission(invoice.status, invoice.receiveDate)" type="submit" (click)="showRejectModal(invoice.id)" class="btn btn-danger">
                        {{ 'storage-invoices-receive.btn.reject' | transloco }}
                      </a>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>

          <div *ngIf="!invoice && isLoading.invoice" class="m-page-loader m-page-loader--non-block m-page-loader--relative">
            <div class="m-loader m-loader--brand"></div>
          </div>
        </div>
      </div>

      <a routerLink="../" class="is--cursor-pointer">
        {{ 'storage-invoices-receive.back' | transloco }}
      </a>
    </div>
  </div>
</div>
